import { useState, type DragEvent } from "react";
import classnames from "classnames";
import Plus from "react-feather/dist/icons/plus";

import style from "./style.module.scss";

interface ImageDropZoneProps {
  loading?: boolean;
  progress?: number;
  className?: string;
  dark?: boolean;
  onDrop?: (files: File[]) => void;
}

function ImageDropZone({ loading, progress = 0, className, dark, onDrop }: ImageDropZoneProps) {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    if (onDrop && e.dataTransfer.files?.length > 0) {
      const imageFiles = [...e.dataTransfer.files].filter((file) => file.type.startsWith("image/"));
      if (imageFiles.length > 0) {
        onDrop(imageFiles);
      }
    }
  };

  return (
    <div
      className={classnames(style.container, className, {
        [style.dark]: dark,
        [style.dragOver]: isDragOver,
      })}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {!loading && (
        <>
          <Plus className={style.icon} />
          <span className={style.text}>Ajouter</span>
        </>
      )}
      {loading && (
        <div className={style.progressOverlay}>
          <div className={style.progressCircle} />
          <span className={style.progressPercent}>{Math.round(progress)}%</span>
        </div>
      )}
    </div>
  );
}

export default ImageDropZone;
